import { render, staticRenderFns } from "./AgePositionCompany.vue?vue&type=template&id=91e5c884&scoped=true&"
import script from "./AgePositionCompany.vue?vue&type=script&lang=js&"
export * from "./AgePositionCompany.vue?vue&type=script&lang=js&"
import style0 from "./AgePositionCompany.vue?vue&type=style&index=0&id=91e5c884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e5c884",
  null
  
)

export default component.exports